import React, { useCallback } from "react";
import PropTypes from "prop-types";
import Heading from "~components/atoms/heading/heading";
import Form from "~components/organisms/form/form";
import ModalCard from "~components/organisms/modal/modal_card/modal_card";
import { formModalWrapperStyle } from "./modal_form.module.scss";

const H1_MARGIN = { marginBottom: "md" };
const SUCCESS_COLOR_STYLE = { color: "#093554" };

function ModalForm({
  formDescription,
  formId,
  formTitle,
  isModalActive,
  lang,
  setModalActiveState,
  conversionType,
}) {
  const closeModal = useCallback(() => {
    return setModalActiveState(false);
  }, [setModalActiveState]);

  return (
    <ModalCard
      callbackToCloseModal={closeModal}
      closeModal={closeModal}
      isModalActive={isModalActive}
    >
      <div className={formModalWrapperStyle}>
        <Heading isCentered visualLevel={3} margin={H1_MARGIN}>
          {formTitle}
        </Heading>
        <Heading isCentered visualLevel={6} seoLevel={5} isBaseFontWeight>
          {formDescription}
        </Heading>
        <Form
          backgroundColor="bright"
          buttonColor="yellow"
          errorColor="red"
          formConversionType={conversionType}
          formId={formId}
          formLabel="resource_hub_contact_form"
          isCentered
          lang={lang}
          layout="multiLine"
          portalId={process.env.HUBSPOT_PORTAL_ID}
          successColor={SUCCESS_COLOR_STYLE}
        />
      </div>
    </ModalCard>
  );
}

ModalForm.propTypes = {
  formDescription: PropTypes.string,
  formId: PropTypes.string,
  formTitle: PropTypes.string,
  conversionType: PropTypes.string,
  isModalActive: PropTypes.bool.isRequired,
  lang: PropTypes.string,
  setModalActiveState: PropTypes.func.isRequired,
};

ModalForm.defaultProps = {
  formTitle: null,
  conversionType: "primary_conversion",
  formDescription: null,
  formId: null,
  lang: "en-gb",
};

export default ModalForm;
